import React from 'react';
import { useTranslation } from 'react-i18next';
import { getEnv } from '@config';
import Button from '../Button';
import Div from '../../AnalyticsDiv';
import classes from './SubmitAndBack.module.scss';

const { publicPath } = getEnv();

export default function Boton({
  handleBack,
  onClick,
  submitText,
  backId = 'back-button',
  submitId = 'submit-button',
  reset,
  isSubmitDisabled = false,
}) {
  const { t } = useTranslation();

  return (
    <div className={classes.Buttons}>
      <Div className={classes.Buttons_back} onClick={handleBack} id={backId}>
        <img src={`${publicPath}/backArrow.svg`} alt="flecha para atras" />
      </Div>
      <Button
        className={reset ? classes.without_width : classes.Buttons_submit}
        onClick={onClick}
        type="submit"
        mediumSize="large"
        id={submitId}
        disabled={isSubmitDisabled}
      >
        {submitText || t('common.buttonNext')}
      </Button>
    </div>
  );
}
